'use client'

import { createContext } from 'use-context-selector'

const RadioGroupContext = createContext<any>(null)
export default RadioGroupContext
